import request from '@/utils/request'

// 查询师傅保证金订单分页
export function pageDepositOrder(data) {
  return request({
    url: '/homeworker/depositOrder/page',
    method: 'post',
    data: data
  })
}

// 导出师傅保证金订单
export function exportDepositOrder(data) {
  return request({
    url: '/homeworker/depositOrder/export',
    method: 'post',
    data: data
  })
}
